import { render, staticRenderFns } from "./ItemMasterInquiry.vue?vue&type=template&id=5314f8f2&scoped=true&"
import script from "./ItemMasterInquiry.vue?vue&type=script&lang=js&"
export * from "./ItemMasterInquiry.vue?vue&type=script&lang=js&"
import style0 from "./ItemMasterInquiry.vue?vue&type=style&index=0&id=5314f8f2&lange=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5314f8f2",
  null
  
)

export default component.exports